import { render, staticRenderFns } from "./AccountPaymentTypeTable.vue?vue&type=template&id=c93541b8&"
import script from "./AccountPaymentTypeTable.vue?vue&type=script&lang=js&"
export * from "./AccountPaymentTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports